module.exports = __webpack_public_path__ + "static/media/purchaseOption-bundleJournal.18460357.svg";